import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDEmphasisSurface, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import { BigFacEnergy } from 'Components/ComponentLibrary/Atoms/Ornament/BigFacEnergy';
import { LearnMoreHereLink } from 'Views/Page/Content/Templates/planSummaryPageTemplate/step/LearnMoreHereLink';

export function TotalValueProduced({ prompt, description, value }) {
  return (
    <BigFacEnergy>
      <FDEmphasisSurface padding={3}>
        <FDStack spacing={1} direction="column">
          <FDBodyText size="sm" value={prompt} align="start" />
          <FDHeadlineText value={value} align="start" />
          <FDBodyText
            align="start"
            size="sm"
            value={
            <>{description}<br /><LearnMoreHereLink /></>
            }
          />
        </FDStack>
      </FDEmphasisSurface>
    </BigFacEnergy>
  );
}

TotalValueProduced.propTypes = {
  prompt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
